import styled, {keyframes} from "styled-components"
import frame01 from "../../../../media/frame01.jpg"
import frame02 from "../../../../media/frame02.jpg"
import frame03 from "../../../../media/frame03.jpg"
import frame04 from "../../../../media/frame04.jpg"

export const Wrapper = styled.div`
  position:absolute;
  left:3%;
  right:3%;
  width:20%;
  height:48%;
  top:34%;  
`

const questionFade = keyframes`
  0%{opacity:0; background:url("${frame01}");transform:scale(.9);}
  1% {opacity:1; background:url("${frame01}");transform:scale(1);}
  24% {opacity:1; background:url("${frame01}"); transform:scale(1);}
  25% {opacity:0; background:url("${frame01}"); transform:scale(1.2);}
  25.1% {opacity:0;background:url("${frame02}"); transform:scale(.9);}
  26% {opacity:1; background:url("${frame02}"); transform:scale(1);}
  49% {opacity:1; background:url("${frame02}"); transform:scale(1);}
  50% {opacity:0; background:url("${frame02}"); transform:scale(1.2);}
  50.1% {opacity:0; background:url("${frame03}"); transform:scale(.9);}
  51% {opacity:1; background:url("${frame03}"); transform:scale(1);}
  74% {opacity:1; background:url("${frame03}"); transform:scale(1);}
  75% {opacity:0; background:url("${frame03}"); transform:scale(1.2);}
  75.1% {opacity:0; background:url("${frame04}"); transform:scale(.9);}
  76% {opacity:1; background:url("${frame04}"); transform:scale(1);}
  100% {opacity:1;background:url("${frame04}");}
`

export const ImageFrames = styled.div`
  position: absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  animation: ${questionFade} 40s linear both .5s;
  transform:origin:center;
`